import { Injectable } from '@angular/core';
import { BaseApi } from './base/base-api';
import { environment } from '../../../environments/environment';
import { NwNumber } from '../../../shared/models/nw-number/nw-number';
import { Observable } from 'rxjs';
import { GroupedNwNumber } from '../../../shared/models/nw-number/grouped-nw-number';
import { AggreatedLanguageTranslationState } from '../../../shared/models/dtc/aggreated-language-translation-state';
import { HttpContext } from '@angular/common/http';
import { SKIP_SPINNER_CONTEXT_TOKEN } from './skip-spinner-context-token';
import { CreateNwNumber } from '../../../shared/models/nw-number/create-nw-number';
import { UpdateNwNumber } from '../../../shared/models/nw-number/update-nw-number';

@Injectable({
  providedIn: 'root',
})
export class NwNumberApiService extends BaseApi {
  constructor() {
    super(environment.api + 'nwnumber');
  }

  public getAllNwNumbers(): Observable<NwNumber[]> {
    return this.http.get<NwNumber[]>(this.baseUrl);
  }

  public getAllGroupedNwNumbers(): Observable<GroupedNwNumber[]> {
    return this.http.get<GroupedNwNumber[]>(this.baseUrl + '/grouped');
  }

  public getByIdAsync(nwNumberId: string, includeApprovalStats = false): Observable<NwNumber> {
    const queryPart = includeApprovalStats ? '?includeApprovalStats=True' : '';
    return this.http.get<NwNumber>(this.baseUrl + '/' + nwNumberId + queryPart);
  }

  public createNwNumber(createNwNumber: CreateNwNumber): Observable<NwNumber> {
    return this.http.post<NwNumber>(this.baseUrl, createNwNumber);
  }

  public getAggregatedTranslationStates(id: string): Observable<AggreatedLanguageTranslationState> {
    return this.http.get<AggreatedLanguageTranslationState>(this.baseUrl + '/aggregated-translation-states/' + id, {
      context: new HttpContext().set(SKIP_SPINNER_CONTEXT_TOKEN, true),
    });
  }

  public updateNwNumber(id: string, updateNwNumber: UpdateNwNumber): Observable<NwNumber> {
    return this.http.put<NwNumber>(this.baseUrl + '/' + id, updateNwNumber);
  }

  public publishSyncEvents(id: string): Observable<void> {
    return this.http.get<void>(this.baseUrl + '/publish-sync-events/' + id);
  }
}
